<template>
  <div class="palette-select">
    <!-- <input style="display:none" type="text" v-model="value" /> -->
    <div
      :style="{ margin: theme == 'default' ? '0 auto' : '' }"
      :class="[uniqueId, {'button-radius' : themeStyleRadius == 'circle' }]"
      class="select-value"
      @click="onOff = !onOff"
    >
      <v-typelist :main="true" layout="left" :palette_config="palette_config" :item="item" :value="value"></v-typelist>
      <svg class="Icon Icon--select-arrow" role="presentation" viewBox="0 0 19 12">
        <polyline
          fill="none"
          stroke="currentColor"
          points="17 2 9.5 10 2 2"
          fill-rule="evenodd"
          stroke-width="2"
          stroke-linecap="square"
        />
      </svg>
    </div>
    <div class="d-md-block d-none">
      <v-popbox
        class="palette-popbox"
        classall="palette-popbox"
        :style="{ padding: 0 }"
        :parentEl="uniqueId"
        :elId="uniqueId"
        :offsetLeft="10"
        :appendToBody="false"
        position="left"
        :onOff="onOff"
      >
        <ul>
          <li
            v-for="subitem in item.value.slice(0, type == 'detail' ? item.value.length : palette_config.show_num)"
            :key="subitem"
            @click="send(subitem)"
            class="text-center"
            :class="{ active: value == subitem }"
          >
            <v-typelist layout="right" :palette_config="palette_config" :item="item" :value="subitem"></v-typelist>
          </li>
        </ul>
      </v-popbox>
    </div>
    <v-mb-select
      :index="index"
      :onOff="onOff"
      :item="item"
      :value="value"
      :palette_config="palette_config"
      :type="type"
      class="d-md-none d-block"
    ></v-mb-select>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import vPopbox from "@/js/components/common/popBox.vue";
import vTypelist from "./typelist";
import vMbSelect from "./mbselect";
export default {
  props: ["value", "item", "palette_config", "type", "index", "theme"],
  data() {
    return {
      getSubitem: null,
      onOff: false
    };
  },
  computed: {
    uniqueId() {
      let { name, a } = this.item
      let unique = this.randomCoding(4)
      let res = name ? name.replace(/[^a-zA-Z0-9]/g, '') + unique : unique
      return res
    },
    ...mapState({
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    }),
  },
  methods: {
    send(val) {
      let obj = {
        index: this.index,
        val
      };
      this.bus.$emit("get_variant", obj);
    },
    resize(){
      const el =  this.$(`.${this.uniqueId}`).offset()?.left
      this.$el.style.setProperty('--palette-select',`${el}px`)
    }
  },
  mounted(){
     this.resize()
      window.addEventListener(
        "resize",
        () => {
          this.resize()
        },
        false
      );
  },
  created() {
    this.bus.$on("get_onoff", res => {
      this.onOff = res;
    });
  },
  components: {
    vTypelist,
    vMbSelect,
    vPopbox,
  }
};
</script>

<style lang="scss" scoped>
.palette-select {
  &::after {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 1px solid transparent;
    border-right: 1px solid gray;
    border-bottom: 1px solid gray;
    border-left: 1px solid transparent;
    margin-right: 4px;
    transition: all 0.3s;
    margin-top: 12px;
    transform: rotate(45deg);
  }

  .select-value {
    max-width: 400px;
    width: 100%;
    height: 46px;
    background: #ffffff;
    border: 1px solid #e3e3e3;
    line-height: 46px;
    padding-left: 6px;
    margin-bottom: 10px;
    position: relative;
    svg {
      overflow: hidden;
      vertical-align: middle;
      pointer-events: none;
      position: absolute;
      top: calc(50% - 5px);
      right: 15px;
      width: 10px;
      height: 10px;
    }
    .palette-select-list {
      height: 45px;
      line-height: 45px;
      padding-right: 42px;
      &:hover {
        font-weight: unset;
      }
      &::v-deep .select-item {
        margin: 6px 0;
        margin-right: 12px;
      }
    }
  }
  ::v-deep {
    ul.select-content-list {
      max-height: 440px;
      overflow: auto;
    }
  }
}
.palette-popbox {
  max-width: var(--palette-select);
  width:  var(--palette-select);
  transform: translateY(calc(-50% + 22.5px));
  -ms-transform: translateY(-50%) translateY(22.5px); /* IE 11 */
  left: calc(100px - var(--palette-select)) !important;
  ul {
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px #dddddd;
    padding: 15px 0;
    list-style: none;
    margin-bottom: 0;
    max-height: 386px;
    overflow: auto;
    li {
      // height: 47px;
      &::v-deep .palette-select-list {
        padding: 0 50px;
        height: unset;
        max-width: unset;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        .select-item {
          margin: 7.5px 0;
          
        }
        .nowarp {
          line-height: 1.5rem;
          max-width: 100%;
          overflow: unset;
          display: block;
          white-space: unset;
          padding: 5px 10px;
          margin-right: 35px;
          flex: 1;
        }
      }
    }
    & > .active {
      background-color: rgba(245, 165, 3, 0.1);
      font-weight: bold;
    }
  }
  &::before {
    content: '';
    position: absolute;
    left: unset;
    top: 50%;
    right: -10px;
    transform: translate(0, -50%);
    border-top: 10px solid transparent;
    border-left: 10px solid #fff;
    border-bottom: 10px solid transparent;
  }
}
</style>
